import { ActionInfo } from "./ActionInfoTypes";

// -----
// *** AUTO COLLECT ACTIONS ***
// -----

//
// Auto Collect (+3 /s) - 10 Basic Actions
//

export const AutoCollect_3005: ActionInfo = {
  id: "auto_collect_3005",
  type: "Auto Collect",
  title: "Brick 1x1 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 10,
    },
    {
      brickId: "3004",
      baseChangeValue: 6,
    },
    {
      brickId: "3024",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3024",
    },
    {
      actionId: "auto_collect_3023",
    },
    {
      actionId: "increase_capacity_3005",
    },
    {
      actionId: "increase_capacity_3004",
    },
    {
      actionId: "increase_capacity_3023",
    },
    {
      actionId: "increase_capacity_3024",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3004: ActionInfo = {
  id: "auto_collect_3004",
  type: "Auto Collect",
  title: "Brick 1x2 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 15,
    },
    {
      brickId: "3004",
      baseChangeValue: 10,
    },
    {
      brickId: "3024",
      baseChangeValue: 18,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3024",
    },
    {
      actionId: "auto_collect_3023",
    },
    {
      actionId: "increase_capacity_3005",
    },
    {
      actionId: "increase_capacity_3004",
    },
    {
      actionId: "increase_capacity_3023",
    },
    {
      actionId: "increase_capacity_3024",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3010: ActionInfo = {
  id: "auto_collect_3010",
  type: "Auto Collect",
  title: "Brick 1x4 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 50,
    },
    {
      brickId: "3024",
      baseChangeValue: 50,
    },
    {
      brickId: "30390",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3003: ActionInfo = {
  id: "auto_collect_3003",
  type: "Auto Collect",
  title: "Brick 2x2 (+3 /s)",
  details: "+1 /s Auto Collect",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 50,
    },
    {
      brickId: "3024",
      baseChangeValue: 50,
    },
    {
      brickId: "30363",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3001: ActionInfo = {
  id: "auto_collect_3001",
  type: "Auto Collect",
  title: "Brick 2x4 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 50,
    },
    {
      brickId: "3024",
      baseChangeValue: 50,
    },
    {
      brickId: "6091",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3024: ActionInfo = {
  id: "auto_collect_3024",
  type: "Auto Collect",
  title: "Plate 1x1 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 15,
    },
    {
      brickId: "3004",
      baseChangeValue: 15,
    },
    {
      brickId: "3024",
      baseChangeValue: 18,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_3005",
    },
    {
      actionId: "increase_capacity_3004",
    },
    {
      actionId: "increase_capacity_3023",
    },
    {
      actionId: "increase_capacity_3024",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3023: ActionInfo = {
  id: "auto_collect_3023",
  type: "Auto Collect",
  title: "Plate 1x2 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 25,
    },
    {
      brickId: "3004",
      baseChangeValue: 20,
    },
    {
      brickId: "3024",
      baseChangeValue: 25,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_3005",
    },
    {
      actionId: "increase_capacity_3004",
    },
    {
      actionId: "increase_capacity_3023",
    },
    {
      actionId: "increase_capacity_3024",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3710: ActionInfo = {
  id: "auto_collect_3710",
  type: "Auto Collect",
  title: "Plate 1x4 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 25,
    },
    {
      brickId: "3024",
      baseChangeValue: 20,
    },
    {
      brickId: "60477",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3022: ActionInfo = {
  id: "auto_collect_3022",
  type: "Auto Collect",
  title: "Plate 2x2 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 25,
    },
    {
      brickId: "3024",
      baseChangeValue: 25,
    },
    {
      brickId: "54200",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3020: ActionInfo = {
  id: "auto_collect_3020",
  type: "Auto Collect",
  title: "Plate 2x4 (+3 /s)",
  details: "+3 /s Auto Collect",
  cost: [
    {
      brickId: "3024",
      baseChangeValue: 25,
    },
    {
      brickId: "3023",
      baseChangeValue: 25,
    },
    {
      brickId: "2752",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Auto Collect (+15 /s) - 10 Upgraded Actions
//

export const AutoCollect_3005_10: ActionInfo = {
  id: "auto_collect_3005_10",
  type: "Auto Collect",
  title: "Brick 1x1 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 80,
    },
    {
      brickId: "3001",
      baseChangeValue: 80,
    },
    {
      brickId: "30363",
      baseChangeValue: 20,
    },
    {
      brickId: "3040",
      baseChangeValue: 20,
    },
    {
      brickId: "30390",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_3005_100",
    },
    {
      actionId: "increase_capacity_3004_100",
    },
    {
      actionId: "increase_capacity_3024_100",
    },
    {
      actionId: "increase_capacity_3023_100",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3004_10: ActionInfo = {
  id: "auto_collect_3004_10",
  type: "Auto Collect",
  title: "Brick 1x2 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 80,
    },
    {
      brickId: "3710",
      baseChangeValue: 80,
    },
    {
      brickId: "3003",
      baseChangeValue: 80,
    },
    {
      brickId: "3039",
      baseChangeValue: 20,
    },
    {
      brickId: "30390",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_3005_100",
    },
    {
      actionId: "increase_capacity_3004_100",
    },
    {
      actionId: "increase_capacity_3024_100",
    },
    {
      actionId: "increase_capacity_3023_100",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3024_10: ActionInfo = {
  id: "auto_collect_3024_10",
  type: "Auto Collect",
  title: "Plate 1x1 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 80,
    },
    {
      brickId: "30363",
      baseChangeValue: 20,
    },
    {
      brickId: "6091",
      baseChangeValue: 20,
    },
    {
      brickId: "30390",
      baseChangeValue: 20,
    },
    {
      brickId: "4349",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_3005_100",
    },
    {
      actionId: "increase_capacity_3004_100",
    },
    {
      actionId: "increase_capacity_3024_100",
    },
    {
      actionId: "increase_capacity_3023_100",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3023_10: ActionInfo = {
  id: "auto_collect_3023_10",
  type: "Auto Collect",
  title: "Plate 1x2 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 80,
    },
    {
      brickId: "4286",
      baseChangeValue: 20,
    },
    {
      brickId: "3039",
      baseChangeValue: 20,
    },
    {
      brickId: "3660",
      baseChangeValue: 20,
    },
    {
      brickId: "3962a",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_3005_100",
    },
    {
      actionId: "increase_capacity_3004_100",
    },
    {
      actionId: "increase_capacity_3024_100",
    },
    {
      actionId: "increase_capacity_3023_100",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_3010_10: ActionInfo = {
  id: "auto_collect_3010_10",
  type: "Auto Collect",
  title: "Brick 1x4 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3710",
      baseChangeValue: 80,
    },
    {
      brickId: "54200",
      baseChangeValue: 20,
    },
    {
      brickId: "30363",
      baseChangeValue: 20,
    },
    {
      brickId: "6091",
      baseChangeValue: 20,
    },
    {
      brickId: "4449",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3003_10: ActionInfo = {
  id: "auto_collect_3003_10",
  type: "Auto Collect",
  title: "Brick 2x2 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 80,
    },
    {
      brickId: "60477",
      baseChangeValue: 20,
    },
    {
      brickId: "30363",
      baseChangeValue: 20,
    },
    {
      brickId: "2752",
      baseChangeValue: 20,
    },
    {
      brickId: "4349",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3001_10: ActionInfo = {
  id: "auto_collect_3001_10",
  type: "Auto Collect",
  title: "Brick 2x4 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 80,
    },
    {
      brickId: "4286",
      baseChangeValue: 20,
    },
    {
      brickId: "2752",
      baseChangeValue: 20,
    },
    {
      brickId: "6091",
      baseChangeValue: 20,
    },
    {
      brickId: "30162",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3710_10: ActionInfo = {
  id: "auto_collect_3710_10",
  type: "Auto Collect",
  title: "Plate 1x4 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3020",
      baseChangeValue: 80,
    },
    {
      brickId: "4286",
      baseChangeValue: 20,
    },
    {
      brickId: "3040",
      baseChangeValue: 20,
    },
    {
      brickId: "2752",
      baseChangeValue: 20,
    },
    {
      brickId: "30228",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3022_10: ActionInfo = {
  id: "auto_collect_3022_10",
  type: "Auto Collect",
  title: "Plate 2x2 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 80,
    },
    {
      brickId: "4286",
      baseChangeValue: 20,
    },
    {
      brickId: "3040",
      baseChangeValue: 20,
    },
    {
      brickId: "2752",
      baseChangeValue: 20,
    },
    {
      brickId: "30228",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3020_10: ActionInfo = {
  id: "auto_collect_3020_10",
  type: "Auto Collect",
  title: "Plate 2x4 (+15 /s)",
  details: "+15 /s Auto Collect",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 80,
    },
    {
      brickId: "30363",
      baseChangeValue: 20,
    },
    {
      brickId: "3040",
      baseChangeValue: 20,
    },
    {
      brickId: "3660",
      baseChangeValue: 20,
    },
    {
      brickId: "93106",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Auto Collect (+75 /s) - 10 High-Level Actions
//

export const AutoCollect_3005_75: ActionInfo = {
  id: "auto_collect_3005_75",
  type: "Auto Collect",
  title: "Brick 1x1 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 4000,
    },
    {
      brickId: "3040",
      baseChangeValue: 3000,
    },
    {
      brickId: "93106",
      baseChangeValue: 3000,
    },
    {
      brickId: "32506",
      baseChangeValue: 3000,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3004_75: ActionInfo = {
  id: "auto_collect_3004_75",
  type: "Auto Collect",
  title: "Brick 1x2 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 4000,
    },
    {
      brickId: "3660",
      baseChangeValue: 3000,
    },
    {
      brickId: "3962a",
      baseChangeValue: 3000,
    },
    {
      brickId: "42074",
      baseChangeValue: 3000,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3024_75: ActionInfo = {
  id: "auto_collect_3024_75",
  type: "Auto Collect",
  title: "Plate 1x1 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 4000,
    },
    {
      brickId: "30363",
      baseChangeValue: 3000,
    },
    {
      brickId: "30228",
      baseChangeValue: 3000,
    },
    {
      brickId: "41671",
      baseChangeValue: 3000,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3023_75: ActionInfo = {
  id: "auto_collect_3023_75",
  type: "Auto Collect",
  title: "Plate 1x2 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3710",
      baseChangeValue: 4000,
    },
    {
      brickId: "2752",
      baseChangeValue: 3000,
    },
    {
      brickId: "3835",
      baseChangeValue: 3000,
    },
    {
      brickId: "43558",
      baseChangeValue: 3000,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3010_75: ActionInfo = {
  id: "auto_collect_3010_75",
  type: "Auto Collect",
  title: "Brick 1x4 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 5000,
    },
    {
      brickId: "54200",
      baseChangeValue: 4000,
    },
    {
      brickId: "30162",
      baseChangeValue: 4000,
    },
    {
      brickId: "42042",
      baseChangeValue: 4000,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 7,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3003_75: ActionInfo = {
  id: "auto_collect_3003_75",
  type: "Auto Collect",
  title: "Brick 2x2 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 5000,
    },
    {
      brickId: "4349",
      baseChangeValue: 4000,
    },
    {
      brickId: "47298",
      baseChangeValue: 4000,
    },
    {
      brickId: "6246f",
      baseChangeValue: 4000,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 7,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3001_75: ActionInfo = {
  id: "auto_collect_3001_75",
  type: "Auto Collect",
  title: "Brick 2x4 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3020",
      baseChangeValue: 5000,
    },
    {
      brickId: "6091",
      baseChangeValue: 4000,
    },
    {
      brickId: "30148",
      baseChangeValue: 4000,
    },
    {
      brickId: "3020",
      baseChangeValue: 4000,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 7,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3710_75: ActionInfo = {
  id: "auto_collect_3710_75",
  type: "Auto Collect",
  title: "Plate 1x4 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3024",
      baseChangeValue: 5000,
    },
    {
      brickId: "30304",
      baseChangeValue: 4000,
    },
    {
      brickId: "42074",
      baseChangeValue: 4000,
    },
    {
      brickId: "64644",
      baseChangeValue: 400,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 7,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3022_75: ActionInfo = {
  id: "auto_collect_3022_75",
  type: "Auto Collect",
  title: "Plate 2x2 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 5000,
    },
    {
      brickId: "93106",
      baseChangeValue: 4000,
    },
    {
      brickId: "42760",
      baseChangeValue: 4000,
    },
    {
      brickId: "36752a",
      baseChangeValue: 400,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 7,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3020_75: ActionInfo = {
  id: "auto_collect_3020_75",
  type: "Auto Collect",
  title: "Plate 2x4 (+75 /s)",
  details: "+75 /s Auto Collect",
  cost: [
    {
      brickId: "3022",
      baseChangeValue: 5000,
    },
    {
      brickId: "4349",
      baseChangeValue: 4000,
    },
    {
      brickId: "42042",
      baseChangeValue: 4000,
    },
    {
      brickId: "30194",
      baseChangeValue: 400,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 7,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Auto Collect (+250 /s) - 10 Advanced Actions
//

export const AutoCollect_3005_250: ActionInfo = {
  id: "auto_collect_3005_250",
  type: "Auto Collect",
  title: "Brick 1x1 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "55297",
      baseChangeValue: 300,
    },
    {
      brickId: "30194",
      baseChangeValue: 300,
    },
    {
      brickId: "32573",
      baseChangeValue: 300,
    },
    {
      brickId: "32566",
      baseChangeValue: 300,
    },
    {
      brickId: "41531",
      baseChangeValue: 45,
    },
    {
      brickId: "2489",
      baseChangeValue: 45,
    },
    {
      brickId: "87991",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3004_250: ActionInfo = {
  id: "auto_collect_3004_250",
  type: "Auto Collect",
  title: "Brick 1x2 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "36752a",
      baseChangeValue: 300,
    },
    {
      brickId: "76764",
      baseChangeValue: 300,
    },
    {
      brickId: "32566",
      baseChangeValue: 300,
    },
    {
      brickId: "32568",
      baseChangeValue: 300,
    },
    {
      brickId: "41531",
      baseChangeValue: 45,
    },
    {
      brickId: "50990b",
      baseChangeValue: 45,
    },
    {
      brickId: "37784",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3024_250: ActionInfo = {
  id: "auto_collect_3024_250",
  type: "Auto Collect",
  title: "Plate 1x1 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "55297",
      baseChangeValue: 300,
    },
    {
      brickId: "30173",
      baseChangeValue: 300,
    },
    {
      brickId: "32567",
      baseChangeValue: 300,
    },
    {
      brickId: "32565",
      baseChangeValue: 300,
    },
    {
      brickId: "4740",
      baseChangeValue: 45,
    },
    {
      brickId: "30139",
      baseChangeValue: 45,
    },
    {
      brickId: "26139",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3023_250: ActionInfo = {
  id: "auto_collect_3023_250",
  type: "Auto Collect",
  title: "Plate 1x2 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "30035",
      baseChangeValue: 300,
    },
    {
      brickId: "64644",
      baseChangeValue: 300,
    },
    {
      brickId: "32573",
      baseChangeValue: 300,
    },
    {
      brickId: "32574",
      baseChangeValue: 300,
    },
    {
      brickId: "6222",
      baseChangeValue: 45,
    },
    {
      brickId: "4285b",
      baseChangeValue: 45,
    },
    {
      brickId: "13768",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3010_250: ActionInfo = {
  id: "auto_collect_3010_250",
  type: "Auto Collect",
  title: "Brick 1x4 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "64567",
      baseChangeValue: 300,
    },
    {
      brickId: "6246f",
      baseChangeValue: 300,
    },
    {
      brickId: "32568",
      baseChangeValue: 300,
    },
    {
      brickId: "32571",
      baseChangeValue: 300,
    },
    {
      brickId: "41531",
      baseChangeValue: 45,
    },
    {
      brickId: "4285b",
      baseChangeValue: 45,
    },
    {
      brickId: "62696",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3003_250: ActionInfo = {
  id: "auto_collect_3003_250",
  type: "Auto Collect",
  title: "Brick 2x2 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "30194",
      baseChangeValue: 300,
    },
    {
      brickId: "36752a",
      baseChangeValue: 300,
    },
    {
      brickId: "32575",
      baseChangeValue: 300,
    },
    {
      brickId: "32566",
      baseChangeValue: 300,
    },
    {
      brickId: "2489",
      baseChangeValue: 45,
    },
    {
      brickId: "30360",
      baseChangeValue: 45,
    },
    {
      brickId: "30410",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 7,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3001_250: ActionInfo = {
  id: "auto_collect_3001_250",
  type: "Auto Collect",
  title: "Brick 2x4 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "30194",
      baseChangeValue: 300,
    },
    {
      brickId: "30229",
      baseChangeValue: 300,
    },
    {
      brickId: "32567",
      baseChangeValue: 300,
    },
    {
      brickId: "32574",
      baseChangeValue: 300,
    },
    {
      brickId: "4740",
      baseChangeValue: 45,
    },
    {
      brickId: "6014b",
      baseChangeValue: 45,
    },
    {
      brickId: "3901",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3710_250: ActionInfo = {
  id: "auto_collect_3710_250",
  type: "Auto Collect",
  title: "Plate 1x4 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "55297",
      baseChangeValue: 300,
    },
    {
      brickId: "64644",
      baseChangeValue: 300,
    },
    {
      brickId: "32570",
      baseChangeValue: 300,
    },
    {
      brickId: "32575",
      baseChangeValue: 300,
    },
    {
      brickId: "3960",
      baseChangeValue: 45,
    },
    {
      brickId: "2489",
      baseChangeValue: 45,
    },
    {
      brickId: "62696",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3022_250: ActionInfo = {
  id: "auto_collect_3022_250",
  type: "Auto Collect",
  title: "Plate 2x2 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "30035",
      baseChangeValue: 300,
    },
    {
      brickId: "30173",
      baseChangeValue: 300,
    },
    {
      brickId: "32565",
      baseChangeValue: 300,
    },
    {
      brickId: "32571",
      baseChangeValue: 300,
    },
    {
      brickId: "30139",
      baseChangeValue: 45,
    },
    {
      brickId: "6222",
      baseChangeValue: 45,
    },
    {
      brickId: "53982",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_3020_250: ActionInfo = {
  id: "auto_collect_3020_250",
  type: "Auto Collect",
  title: "Plate 2x4 (+250 /s)",
  details: "+250 /s Auto Collect",
  cost: [
    {
      brickId: "6246f",
      baseChangeValue: 300,
    },
    {
      brickId: "64567",
      baseChangeValue: 300,
    },
    {
      brickId: "32505",
      baseChangeValue: 300,
    },
    {
      brickId: "32573",
      baseChangeValue: 300,
    },
    {
      brickId: "30360",
      baseChangeValue: 45,
    },
    {
      brickId: "4285b",
      baseChangeValue: 45,
    },
    {
      brickId: "26139",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 250,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Brick Pack Auto Collect - 2 Special Actions
//

export const AutoCollect_BrickPack_SlopedBricksPartOne: ActionInfo = {
  id: "auto_collect_brickpack_sloped_bricks_part_one",
  type: "Auto Collect",
  title: "Sloped Bricks #1 (+3 /s)",
  details: "+3 /s Auto Collect Sloped Bricks #1",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 1000,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 20,
      type: "set",
    },
    {
      brickId: "8534-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "54200",
      baseChangeValue: 3,
    },
    {
      brickId: "3040",
      baseChangeValue: 3,
    },
    {
      brickId: "4286",
      baseChangeValue: 3,
    },
    {
      brickId: "60477",
      baseChangeValue: 3,
    },
    {
      brickId: "3039",
      baseChangeValue: 3,
    },
    {
      brickId: "30363",
      baseChangeValue: 3,
    },
    {
      brickId: "3660",
      baseChangeValue: 3,
    },
    {
      brickId: "2752",
      baseChangeValue: 3,
    },
    {
      brickId: "30390",
      baseChangeValue: 3,
    },
    {
      brickId: "6091",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigUtensilsPartOne: ActionInfo = {
  id: "auto_collect_brickpack_minifig_utensils_part_one",
  type: "Auto Collect",
  title: "Minifig Utnls #1 (+3 /s)",
  details: "+3 /s Auto Collect Minifig Utensils #1",
  cost: [
    {
      brickId: "6086",
      baseChangeValue: 5,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 5,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "4349",
      baseChangeValue: 3,
    },
    {
      brickId: "30162",
      baseChangeValue: 3,
    },
    {
      brickId: "30228",
      baseChangeValue: 3,
    },
    {
      brickId: "6246a",
      baseChangeValue: 3,
    },
    {
      brickId: "30148",
      baseChangeValue: 3,
    },
    {
      brickId: "93106",
      baseChangeValue: 3,
    },
    {
      brickId: "4449",
      baseChangeValue: 3,
    },
    {
      brickId: "30304",
      baseChangeValue: 3,
    },
    {
      brickId: "3962a",
      baseChangeValue: 3,
    },
    {
      brickId: "3835",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_BioniclesPartOne: ActionInfo = {
  id: "auto_collect_brickpack_bionicles_part_one",
  type: "Auto Collect",
  title: "Bionicles #1 (+3 /s)",
  details: "+3 /s Auto Collect Bionicles #1",
  cost: [
    {
      brickId: "4493c01pb02",
      baseChangeValue: 5,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 5,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "x346",
      baseChangeValue: 3,
    },
    {
      brickId: "42074",
      baseChangeValue: 3,
    },
    {
      brickId: "32553",
      baseChangeValue: 3,
    },
    {
      brickId: "42760",
      baseChangeValue: 3,
    },
    {
      brickId: "32506",
      baseChangeValue: 3,
    },
    {
      brickId: "42042",
      baseChangeValue: 3,
    },
    {
      brickId: "43558",
      baseChangeValue: 3,
    },
    {
      brickId: "41671",
      baseChangeValue: 3,
    },
    {
      brickId: "54271",
      baseChangeValue: 3,
    },
    {
      brickId: "47298",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_CircularBricks: ActionInfo = {
  id: "auto_collect_brickpack_circular_bricks",
  type: "Auto Collect",
  title: "Circular Bricks (+3 /s)",
  details: "+3 /s Auto Collect Circular Bricks",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 750,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "4740",
      baseChangeValue: 3,
    },
    {
      brickId: "6014b",
      baseChangeValue: 3,
    },
    {
      brickId: "3960",
      baseChangeValue: 3,
    },
    {
      brickId: "50990b",
      baseChangeValue: 3,
    },
    {
      brickId: "2489",
      baseChangeValue: 3,
    },
    {
      brickId: "30139",
      baseChangeValue: 3,
    },
    {
      brickId: "6222",
      baseChangeValue: 3,
    },
    {
      brickId: "41531",
      baseChangeValue: 3,
    },
    {
      brickId: "30360",
      baseChangeValue: 3,
    },
    {
      brickId: "4285b",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_SlopedBricksPartOne_15: ActionInfo = {
  id: "auto_collect_brickpack_sloped_bricks_part_one_15",
  type: "Auto Collect",
  title: "Sloped Bricks #1 (+15 /s)",
  details: "+15 /s Auto Collect Sloped Bricks #1",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 3000,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 30,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 30,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "54200",
      baseChangeValue: 15,
    },
    {
      brickId: "3040",
      baseChangeValue: 15,
    },
    {
      brickId: "4286",
      baseChangeValue: 15,
    },
    {
      brickId: "60477",
      baseChangeValue: 15,
    },
    {
      brickId: "3039",
      baseChangeValue: 15,
    },
    {
      brickId: "30363",
      baseChangeValue: 15,
    },
    {
      brickId: "3660",
      baseChangeValue: 15,
    },
    {
      brickId: "2752",
      baseChangeValue: 15,
    },
    {
      brickId: "30390",
      baseChangeValue: 15,
    },
    {
      brickId: "6091",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigUtensilsPartOne_15: ActionInfo = {
  id: "auto_collect_brickpack_minifig_utensils_part_one_15",
  type: "Auto Collect",
  title: "Minifig Utnls #1 (+15 /s)",
  details: "+15 /s Auto Collect Minifig Utensils #1",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 3000,
    },
    {
      brickId: "3710",
      baseChangeValue: 3000,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 35,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 30,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "4349",
      baseChangeValue: 15,
    },
    {
      brickId: "30162",
      baseChangeValue: 15,
    },
    {
      brickId: "30228",
      baseChangeValue: 15,
    },
    {
      brickId: "6246a",
      baseChangeValue: 15,
    },
    {
      brickId: "30148",
      baseChangeValue: 15,
    },
    {
      brickId: "93106",
      baseChangeValue: 15,
    },
    {
      brickId: "4449",
      baseChangeValue: 15,
    },
    {
      brickId: "30304",
      baseChangeValue: 15,
    },
    {
      brickId: "3962a",
      baseChangeValue: 15,
    },
    {
      brickId: "3835",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_BioniclesPartOne_15: ActionInfo = {
  id: "auto_collect_brickpack_bionicles_part_one_15",
  type: "Auto Collect",
  title: "Bionicles #1 (+15 /s)",
  details: "+15 /s Auto Collect Bionicles #1",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 3000,
    },
    {
      brickId: "3022",
      baseChangeValue: 3000,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 35,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 35,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "x346",
      baseChangeValue: 15,
    },
    {
      brickId: "42074",
      baseChangeValue: 15,
    },
    {
      brickId: "32553",
      baseChangeValue: 15,
    },
    {
      brickId: "42760",
      baseChangeValue: 15,
    },
    {
      brickId: "32506",
      baseChangeValue: 15,
    },
    {
      brickId: "42042",
      baseChangeValue: 15,
    },
    {
      brickId: "43558",
      baseChangeValue: 15,
    },
    {
      brickId: "41671",
      baseChangeValue: 15,
    },
    {
      brickId: "54271",
      baseChangeValue: 15,
    },
    {
      brickId: "47298",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_AnimalsPartOne_15: ActionInfo = {
  id: "auto_collect_brickpack_animals_part_one_15",
  type: "Auto Collect",
  title: "Animals #1 (+15 /s)",
  details: "+15 /s Auto Collect Animals #1",
  cost: [
    {
      brickId: "3022",
      baseChangeValue: 3000,
    },
    {
      brickId: "47298",
      baseChangeValue: 1200,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 30,
      type: "set",
    },
    {
      brickId: "7146-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "4493c01pb02",
      baseChangeValue: 15,
    },
    {
      brickId: "6086",
      baseChangeValue: 15,
    },
    {
      brickId: "48812",
      baseChangeValue: 15,
    },
    {
      brickId: "30464",
      baseChangeValue: 15,
    },
    {
      brickId: "30103",
      baseChangeValue: 15,
    },
    {
      brickId: "30115",
      baseChangeValue: 15,
    },
    {
      brickId: "92084",
      baseChangeValue: 15,
    },
    {
      brickId: "80674",
      baseChangeValue: 15,
    },
    {
      brickId: "33121",
      baseChangeValue: 15,
    },
    {
      brickId: "30238",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [
    {
      actionId: "upgrade_brickpack_circular_bricks",
    },
    {
      actionId: "upgrade_brickpack_minifig_hair",
    },
    {
      actionId: "upgrade_brickpack_technic_bricks",
    },
    {
      actionId: "upgrade_brickpack_minifig_headgear",
    },
    {
      actionId: "increase_capacity_brickpack_circular_bricks",
    },
    {
      actionId: "increase_capacity_brickpack_minifig_hair",
    },
    {
      actionId: "increase_capacity_brickpack_technic_bricks",
    },
    {
      actionId: "increase_capacity_brickpack_minifig_headgear",
    },
    {
      actionId: "auto_collect_brickpack_circular_bricks",
    },
    {
      actionId: "auto_collect_brickpack_minifig_hair",
    },
    {
      actionId: "auto_collect_brickpack_technic_bricks",
    },
    {
      actionId: "auto_collect_brickpack_minifig_headgear",
    },
  ],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigUtensilsPartTwo_15: ActionInfo = {
  id: "auto_collect_brickpack_minifig_utensils_part_two_15",
  type: "Auto Collect",
  title: "Minifig Utnls #2 (+15 /s)",
  details: "+15 /s Auto Collect Minifig Utensils #2",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 3000,
    },
    {
      brickId: "54271",
      baseChangeValue: 1300,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 15,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "30035",
      baseChangeValue: 15,
    },
    {
      brickId: "30173",
      baseChangeValue: 15,
    },
    {
      brickId: "76764",
      baseChangeValue: 15,
    },
    {
      brickId: "64644",
      baseChangeValue: 15,
    },
    {
      brickId: "6246f",
      baseChangeValue: 15,
    },
    {
      brickId: "55297",
      baseChangeValue: 15,
    },
    {
      brickId: "36752a",
      baseChangeValue: 15,
    },
    {
      brickId: "30229",
      baseChangeValue: 15,
    },
    {
      brickId: "30194",
      baseChangeValue: 15,
    },
    {
      brickId: "64567",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_BioniclesPartTwo_15: ActionInfo = {
  id: "auto_collect_brickpack_bionicles_part_two_15",
  type: "Auto Collect",
  title: "Bionicles #2 (+15 /s)",
  details: "+15 /s Auto Collect Bionicles #2",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 3000,
    },
    {
      brickId: "6246a",
      baseChangeValue: 2000,
    },
    {
      brickId: "42760",
      baseChangeValue: 1300,
    },
    {
      brickId: "4866-1",
      baseChangeValue: 40,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "32567",
      baseChangeValue: 15,
    },
    {
      brickId: "32574",
      baseChangeValue: 15,
    },
    {
      brickId: "32570",
      baseChangeValue: 15,
    },
    {
      brickId: "32575",
      baseChangeValue: 15,
    },
    {
      brickId: "32566",
      baseChangeValue: 15,
    },
    {
      brickId: "32565",
      baseChangeValue: 15,
    },
    {
      brickId: "32571",
      baseChangeValue: 15,
    },
    {
      brickId: "32568",
      baseChangeValue: 15,
    },
    {
      brickId: "32505",
      baseChangeValue: 15,
    },
    {
      brickId: "32573",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigHair: ActionInfo = {
  id: "auto_collect_brickpack_minifig_hair",
  type: "Auto Collect",
  title: "Minifig Hair (+3 /s)",
  details: "+3 /s Auto Collect Minifig Hair",
  cost: [
    {
      brickId: "32575",
      baseChangeValue: 50,
    },
    {
      brickId: "32574",
      baseChangeValue: 50,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 150,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 100,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3901",
      baseChangeValue: 3,
    },
    {
      brickId: "62696",
      baseChangeValue: 3,
    },
    {
      brickId: "53982",
      baseChangeValue: 3,
    },
    {
      brickId: "53981",
      baseChangeValue: 3,
    },
    {
      brickId: "26139",
      baseChangeValue: 3,
    },
    {
      brickId: "42444",
      baseChangeValue: 3,
    },
    {
      brickId: "30410",
      baseChangeValue: 3,
    },
    {
      brickId: "87991",
      baseChangeValue: 3,
    },
    {
      brickId: "13768",
      baseChangeValue: 3,
    },
    {
      brickId: "37784",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_TechnicBricks: ActionInfo = {
  id: "auto_collect_brickpack_technic_bricks",
  type: "Auto Collect",
  title: "Technic Bricks (+3 /s)",
  details: "+3 /s Auto Collect Technic Bricks",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 5000,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3713",
      baseChangeValue: 3,
    },
    {
      brickId: "3749",
      baseChangeValue: 3,
    },
    {
      brickId: "24316",
      baseChangeValue: 3,
    },
    {
      brickId: "73230",
      baseChangeValue: 3,
    },
    {
      brickId: "3701",
      baseChangeValue: 3,
    },
    {
      brickId: "32174",
      baseChangeValue: 3,
    },
    {
      brickId: "32034",
      baseChangeValue: 3,
    },
    {
      brickId: "3648",
      baseChangeValue: 3,
    },
    {
      brickId: "3736",
      baseChangeValue: 3,
    },
    {
      brickId: "32168",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigHeadgear: ActionInfo = {
  id: "auto_collect_brickpack_minifig_headgear",
  type: "Auto Collect",
  title: "Minifig Headgear (+3 /s)",
  details: "+3 /s Auto Collect Minifig Headgear",
  cost: [
    {
      brickId: "3648",
      baseChangeValue: 25,
    },
    {
      brickId: "73230",
      baseChangeValue: 25,
    },
    {
      brickId: "26139",
      baseChangeValue: 35,
    },
    {
      brickId: "53981",
      baseChangeValue: 35,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 50,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 15,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "3898",
      baseChangeValue: 3,
    },
    {
      brickId: "30202",
      baseChangeValue: 3,
    },
    {
      brickId: "x164",
      baseChangeValue: 3,
    },
    {
      brickId: "3485",
      baseChangeValue: 3,
    },
    {
      brickId: "x52",
      baseChangeValue: 3,
    },
    {
      brickId: "2528",
      baseChangeValue: 3,
    },
    {
      brickId: "3624",
      baseChangeValue: 3,
    },
    {
      brickId: "30325",
      baseChangeValue: 3,
    },
    {
      brickId: "30167",
      baseChangeValue: 3,
    },
    {
      brickId: "30381",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_CircularBricks_15: ActionInfo = {
  id: "auto_collect_brickpack_circular_bricks_15",
  type: "Auto Collect",
  title: "Circular Bricks (+15 /s)",
  details: "+15 /s Auto Collect Circular Bricks",
  cost: [
    {
      brickId: "3901",
      baseChangeValue: 60,
    },
    {
      brickId: "62696",
      baseChangeValue: 60,
    },
    {
      brickId: "3713",
      baseChangeValue: 45,
    },
    {
      brickId: "3749",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10179-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "4740",
      baseChangeValue: 15,
    },
    {
      brickId: "6014b",
      baseChangeValue: 15,
    },
    {
      brickId: "3960",
      baseChangeValue: 15,
    },
    {
      brickId: "50990b",
      baseChangeValue: 15,
    },
    {
      brickId: "2489",
      baseChangeValue: 15,
    },
    {
      brickId: "30139",
      baseChangeValue: 15,
    },
    {
      brickId: "6222",
      baseChangeValue: 15,
    },
    {
      brickId: "41531",
      baseChangeValue: 15,
    },
    {
      brickId: "30360",
      baseChangeValue: 15,
    },
    {
      brickId: "4285b",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigHair_15: ActionInfo = {
  id: "auto_collect_brickpack_minifig_hair_15",
  type: "Auto Collect",
  title: "Minifig Hair (+15 /s)",
  details: "+15 /s Auto Collect Minifig Hair",
  cost: [
    {
      brickId: "53982",
      baseChangeValue: 60,
    },
    {
      brickId: "53981",
      baseChangeValue: 60,
    },
    {
      brickId: "24316",
      baseChangeValue: 45,
    },
    {
      brickId: "73230",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10179-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "3901",
      baseChangeValue: 15,
    },
    {
      brickId: "62696",
      baseChangeValue: 15,
    },
    {
      brickId: "53982",
      baseChangeValue: 15,
    },
    {
      brickId: "53981",
      baseChangeValue: 15,
    },
    {
      brickId: "26139",
      baseChangeValue: 15,
    },
    {
      brickId: "42444",
      baseChangeValue: 15,
    },
    {
      brickId: "30410",
      baseChangeValue: 15,
    },
    {
      brickId: "87991",
      baseChangeValue: 15,
    },
    {
      brickId: "13768",
      baseChangeValue: 15,
    },
    {
      brickId: "37784",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_TechnicBricks_15: ActionInfo = {
  id: "auto_collect_brickpack_technic_bricks_15",
  type: "Auto Collect",
  title: "Technic Bricks (+15 /s)",
  details: "+15 /s Auto Collect Technic Bricks",
  cost: [
    {
      brickId: "26139",
      baseChangeValue: 60,
    },
    {
      brickId: "42444",
      baseChangeValue: 60,
    },
    {
      brickId: "3701",
      baseChangeValue: 45,
    },
    {
      brickId: "32174",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10179-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "3713",
      baseChangeValue: 15,
    },
    {
      brickId: "3749",
      baseChangeValue: 15,
    },
    {
      brickId: "24316",
      baseChangeValue: 15,
    },
    {
      brickId: "73230",
      baseChangeValue: 15,
    },
    {
      brickId: "3701",
      baseChangeValue: 15,
    },
    {
      brickId: "32174",
      baseChangeValue: 15,
    },
    {
      brickId: "32034",
      baseChangeValue: 15,
    },
    {
      brickId: "3648",
      baseChangeValue: 15,
    },
    {
      brickId: "3736",
      baseChangeValue: 15,
    },
    {
      brickId: "32168",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigHeadgear_15: ActionInfo = {
  id: "auto_collect_brickpack_minifig_headgear_15",
  type: "Auto Collect",
  title: "Minifig Hdgr (+15 /s)",
  details: "+15 /s Auto Collect Minifig Headgear",
  cost: [
    {
      brickId: "30410",
      baseChangeValue: 60,
    },
    {
      brickId: "87991",
      baseChangeValue: 60,
    },
    {
      brickId: "32034",
      baseChangeValue: 45,
    },
    {
      brickId: "3648",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10179-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "3898",
      baseChangeValue: 15,
    },
    {
      brickId: "30202",
      baseChangeValue: 15,
    },
    {
      brickId: "x164",
      baseChangeValue: 15,
    },
    {
      brickId: "3485",
      baseChangeValue: 15,
    },
    {
      brickId: "x52",
      baseChangeValue: 15,
    },
    {
      brickId: "2528",
      baseChangeValue: 15,
    },
    {
      brickId: "3624",
      baseChangeValue: 15,
    },
    {
      brickId: "30325",
      baseChangeValue: 15,
    },
    {
      brickId: "30167",
      baseChangeValue: 15,
    },
    {
      brickId: "30381",
      baseChangeValue: 15,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_AnimalsPartOne: ActionInfo = {
  id: "auto_collect_brickpack_animals_part_one",
  type: "Auto Collect",
  title: "Animals #1 (+3 /s)",
  details: "+3 /s Auto Collect Animals #1",
  cost: [
    {
      brickId: "3022",
      baseChangeValue: 750,
    },
    {
      brickId: "30115",
      baseChangeValue: 15,
    },
    {
      brickId: "92084",
      baseChangeValue: 15,
    },
    {
      brickId: "80674",
      baseChangeValue: 15,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 7,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "4493c01pb02",
      baseChangeValue: 3,
    },
    {
      brickId: "6086",
      baseChangeValue: 3,
    },
    {
      brickId: "48812",
      baseChangeValue: 3,
    },
    {
      brickId: "30464",
      baseChangeValue: 3,
    },
    {
      brickId: "30103",
      baseChangeValue: 3,
    },
    {
      brickId: "30115",
      baseChangeValue: 3,
    },
    {
      brickId: "92084",
      baseChangeValue: 3,
    },
    {
      brickId: "80674",
      baseChangeValue: 3,
    },
    {
      brickId: "33121",
      baseChangeValue: 3,
    },
    {
      brickId: "30238",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigUtensilsPartTwo: ActionInfo = {
  id: "auto_collect_brickpack_minifig_utensils_part_two",
  type: "Auto Collect",
  title: "Minifig Utnls #2 (+3 /s)",
  details: "+3 /s Auto Collect Minifig Utensils #2",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 750,
    },
    {
      brickId: "55297",
      baseChangeValue: 15,
    },
    {
      brickId: "36752a",
      baseChangeValue: 15,
    },
    {
      brickId: "30229",
      baseChangeValue: 15,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 15,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "30035",
      baseChangeValue: 3,
    },
    {
      brickId: "30173",
      baseChangeValue: 3,
    },
    {
      brickId: "76764",
      baseChangeValue: 3,
    },
    {
      brickId: "64644",
      baseChangeValue: 3,
    },
    {
      brickId: "6246f",
      baseChangeValue: 3,
    },
    {
      brickId: "55297",
      baseChangeValue: 3,
    },
    {
      brickId: "36752a",
      baseChangeValue: 3,
    },
    {
      brickId: "30229",
      baseChangeValue: 3,
    },
    {
      brickId: "30194",
      baseChangeValue: 3,
    },
    {
      brickId: "64567",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_BioniclesPartTwo: ActionInfo = {
  id: "auto_collect_brickpack_bionicles_part_two",
  type: "Auto Collect",
  title: "Bionicles #2 (+3 /s)",
  details: "+3 /s Auto Collect Bionicles #2",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 750,
    },
    {
      brickId: "32565",
      baseChangeValue: 10,
    },
    {
      brickId: "32571",
      baseChangeValue: 10,
    },
    {
      brickId: "32568",
      baseChangeValue: 10,
    },
    {
      brickId: "4432-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "7146-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "32567",
      baseChangeValue: 3,
    },
    {
      brickId: "32574",
      baseChangeValue: 3,
    },
    {
      brickId: "32570",
      baseChangeValue: 3,
    },
    {
      brickId: "32575",
      baseChangeValue: 3,
    },
    {
      brickId: "32566",
      baseChangeValue: 3,
    },
    {
      brickId: "32565",
      baseChangeValue: 3,
    },
    {
      brickId: "32571",
      baseChangeValue: 3,
    },
    {
      brickId: "32568",
      baseChangeValue: 3,
    },
    {
      brickId: "32505",
      baseChangeValue: 3,
    },
    {
      brickId: "32573",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Brick Pack Auto Collect (+75 /s) - 3 New Actions
//

export const AutoCollect_BrickPack_SlopedBricksPartOne_75: ActionInfo = {
  id: "auto_collect_brickpack_sloped_bricks_part_one_75",
  type: "Auto Collect",
  title: "Sloped Bricks #1 (+75 /s)",
  details: "+75 /s Auto Collect Sloped Bricks #1",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 4000,
    },
    {
      brickId: "32553",
      baseChangeValue: 1000,
    },
    {
      brickId: "6086",
      baseChangeValue: 400,
    },
    {
      brickId: "30229",
      baseChangeValue: 300,
    },
    {
      brickId: "32565",
      baseChangeValue: 200,
    },
    {
      brickId: "30360",
      baseChangeValue: 15,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "54200",
      baseChangeValue: 75,
    },
    {
      brickId: "3040",
      baseChangeValue: 75,
    },
    {
      brickId: "4286",
      baseChangeValue: 75,
    },
    {
      brickId: "60477",
      baseChangeValue: 75,
    },
    {
      brickId: "3039",
      baseChangeValue: 75,
    },
    {
      brickId: "30363",
      baseChangeValue: 75,
    },
    {
      brickId: "3660",
      baseChangeValue: 75,
    },
    {
      brickId: "2752",
      baseChangeValue: 75,
    },
    {
      brickId: "30390",
      baseChangeValue: 75,
    },
    {
      brickId: "6091",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigUtensilsPartOne_75: ActionInfo = {
  id: "auto_collect_brickpack_minifig_utensils_part_one_75",
  type: "Auto Collect",
  title: "Minifig Utnls #1 (+75 /s)",
  details: "+75 /s Auto Collect Minifig Utensils #1",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 4000,
    },
    {
      brickId: "32553",
      baseChangeValue: 1000,
    },
    {
      brickId: "30103",
      baseChangeValue: 400,
    },
    {
      brickId: "64567",
      baseChangeValue: 300,
    },
    {
      brickId: "32570",
      baseChangeValue: 200,
    },
    {
      brickId: "4285b",
      baseChangeValue: 15,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "4349",
      baseChangeValue: 75,
    },
    {
      brickId: "30162",
      baseChangeValue: 75,
    },
    {
      brickId: "30228",
      baseChangeValue: 75,
    },
    {
      brickId: "6246a",
      baseChangeValue: 75,
    },
    {
      brickId: "30148",
      baseChangeValue: 75,
    },
    {
      brickId: "93106",
      baseChangeValue: 75,
    },
    {
      brickId: "4449",
      baseChangeValue: 75,
    },
    {
      brickId: "30304",
      baseChangeValue: 75,
    },
    {
      brickId: "3962a",
      baseChangeValue: 75,
    },
    {
      brickId: "3835",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_BioniclesPartOne_75: ActionInfo = {
  id: "auto_collect_brickpack_bionicles_part_one_75",
  type: "Auto Collect",
  title: "Bionicles #1 (+75 /s)",
  details: "+75 /s Auto Collect Bionicles #1",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 4000,
    },
    {
      brickId: "4349",
      baseChangeValue: 1000,
    },
    {
      brickId: "30162",
      baseChangeValue: 400,
    },
    {
      brickId: "30228",
      baseChangeValue: 300,
    },
    {
      brickId: "93106",
      baseChangeValue: 200,
    },
    {
      brickId: "3835",
      baseChangeValue: 15,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 5,
  outcome: [
    {
      brickId: "x346",
      baseChangeValue: 75,
    },
    {
      brickId: "42074",
      baseChangeValue: 75,
    },
    {
      brickId: "32553",
      baseChangeValue: 75,
    },
    {
      brickId: "42760",
      baseChangeValue: 75,
    },
    {
      brickId: "32506",
      baseChangeValue: 75,
    },
    {
      brickId: "42042",
      baseChangeValue: 75,
    },
    {
      brickId: "43558",
      baseChangeValue: 75,
    },
    {
      brickId: "41671",
      baseChangeValue: 75,
    },
    {
      brickId: "54271",
      baseChangeValue: 75,
    },
    {
      brickId: "47298",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_AnimalsPartOne_75: ActionInfo = {
  id: "auto_collect_brickpack_animals_part_one_75",
  type: "Auto Collect",
  title: "Animals #1 (+75 /s)",
  details: "+75 /s Auto Collect Animals #1",
  cost: [
    {
      brickId: "30410",
      baseChangeValue: 60,
    },
    {
      brickId: "87991",
      baseChangeValue: 60,
    },
    {
      brickId: "32034",
      baseChangeValue: 45,
    },
    {
      brickId: "3648",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 5,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "4493c01pb02",
      baseChangeValue: 75,
    },
    {
      brickId: "6086",
      baseChangeValue: 75,
    },
    {
      brickId: "48812",
      baseChangeValue: 75,
    },
    {
      brickId: "30464",
      baseChangeValue: 75,
    },
    {
      brickId: "30103",
      baseChangeValue: 75,
    },
    {
      brickId: "30115",
      baseChangeValue: 75,
    },
    {
      brickId: "92084",
      baseChangeValue: 75,
    },
    {
      brickId: "80674",
      baseChangeValue: 75,
    },
    {
      brickId: "33121",
      baseChangeValue: 75,
    },
    {
      brickId: "30238",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_MinifigUtensilsPartTwo_75: ActionInfo = {
  id: "auto_collect_brickpack_minifig_utensils_part_two_75",
  type: "Auto Collect",
  title: "Minifig Utnls #2 (+75 /s)",
  details: "+75 /s Auto Collect Minifig Utensils #2",
  cost: [
    {
      brickId: "13768",
      baseChangeValue: 40,
    },
    {
      brickId: "37784",
      baseChangeValue: 40,
    },
    {
      brickId: "3736",
      baseChangeValue: 35,
    },
    {
      brickId: "32168",
      baseChangeValue: 35,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 5,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "30035",
      baseChangeValue: 75,
    },
    {
      brickId: "30173",
      baseChangeValue: 75,
    },
    {
      brickId: "76764",
      baseChangeValue: 75,
    },
    {
      brickId: "64644",
      baseChangeValue: 75,
    },
    {
      brickId: "6246f",
      baseChangeValue: 75,
    },
    {
      brickId: "55297",
      baseChangeValue: 75,
    },
    {
      brickId: "36752a",
      baseChangeValue: 75,
    },
    {
      brickId: "30229",
      baseChangeValue: 75,
    },
    {
      brickId: "30194",
      baseChangeValue: 75,
    },
    {
      brickId: "64567",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const AutoCollect_BrickPack_BioniclesPartTwo_75: ActionInfo = {
  id: "auto_collect_brickpack_bionicles_part_two_75",
  type: "Auto Collect",
  title: "Bionicles #2 (+75 /s)",
  details: "+75 /s Auto Collect Bionicles #2",
  cost: [
    {
      brickId: "3901",
      baseChangeValue: 40,
    },
    {
      brickId: "62696",
      baseChangeValue: 40,
    },
    {
      brickId: "3713",
      baseChangeValue: 35,
    },
    {
      brickId: "3749",
      baseChangeValue: 35,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 5,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 2,
  outcome: [
    {
      brickId: "32567",
      baseChangeValue: 75,
    },
    {
      brickId: "32574",
      baseChangeValue: 75,
    },
    {
      brickId: "32570",
      baseChangeValue: 75,
    },
    {
      brickId: "32575",
      baseChangeValue: 75,
    },
    {
      brickId: "32566",
      baseChangeValue: 75,
    },
    {
      brickId: "32565",
      baseChangeValue: 75,
    },
    {
      brickId: "32571",
      baseChangeValue: 75,
    },
    {
      brickId: "32568",
      baseChangeValue: 75,
    },
    {
      brickId: "32505",
      baseChangeValue: 75,
    },
    {
      brickId: "32573",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};
